import { styled } from '@nykaa/ui-components';
import { BASE_GUTTER_SPACE } from 'shared/styles/base';
import { fadeIn } from 'shared/styles/animations/fadeIn';

export const ListingContainer = styled.div<{ positionRight: boolean }>`
  position: absolute;
  max-height: 300px;
  width: auto;

  ${(props) => (props.positionRight ? `right: 6px;` : ``)}
  left: initial;

  .content {
    background: white;
    box-shadow: 0px -4px 4px rgba(0, 19, 37, 0.08), 0px 4px 8px rgba(0, 19, 37, 0.08);
    border-radius: 2px;
    overflow: hidden;
    padding: ${BASE_GUTTER_SPACE * 2}px ${BASE_GUTTER_SPACE * 2}px;
    max-height: 392px;
    width: fit-content;
    position: relative;
  }

  .inline {
    display: inline-block;
    vertical-align: top;
  }

  ${fadeIn};
`;
